function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { timestamp, isURL } from "../utils.js";
import { ResourceTiming, SetNodeAttributeURLBased, SetNodeAttribute } from "../common/messages.js";
import { hasTag } from "../app/guards.js";

function resolveURL(url) {
  var location = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document.location;
  url = url.trim();

  if (url.startsWith('/')) {
    return location.origin + url;
  } else if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith('data:') // any other possible value here?
  ) {
    return url;
  } else {
    return location.origin + location.pathname + url;
  }
}

var PLACEHOLDER_SRC = "https://static.openreplay.com/tracker/placeholder.jpeg";
export default function (app) {
  function sendPlaceholder(id, node) {
    app.send(new SetNodeAttribute(id, "src", PLACEHOLDER_SRC));

    var _node$getBoundingClie = node.getBoundingClientRect(),
        width = _node$getBoundingClie.width,
        height = _node$getBoundingClie.height;

    if (!node.hasAttribute("width")) {
      app.send(new SetNodeAttribute(id, "width", String(width)));
    }

    if (!node.hasAttribute("height")) {
      app.send(new SetNodeAttribute(id, "height", String(height)));
    }
  }

  var sendImgSrc = app.safe(function () {
    var id = app.nodes.getID(this);

    if (id === undefined) {
      return;
    }

    var src = this.src,
        complete = this.complete,
        naturalWidth = this.naturalWidth,
        naturalHeight = this.naturalHeight,
        srcset = this.srcset;

    if (!complete) {
      return;
    }

    var resolvedSrc = resolveURL(src || ''); // Src type is null sometimes. - is it true?

    if (naturalWidth === 0 && naturalHeight === 0) {
      if (isURL(resolvedSrc)) {
        app.send(new ResourceTiming(timestamp(), 0, 0, 0, 0, 0, resolvedSrc, 'img'));
      }
    } else if (resolvedSrc.length >= 1e5 || app.sanitizer.isMasked(id)) {
      sendPlaceholder(id, this);
    } else {
      app.send(new SetNodeAttribute(id, 'src', resolvedSrc));

      if (srcset) {
        var resolvedSrcset = srcset.split(',').map(function (str) {
          return resolveURL(str);
        }).join(',');
        app.send(new SetNodeAttribute(id, 'srcset', resolvedSrcset));
      }
    }
  });
  var observer = new MutationObserver(function (mutations) {
    var _iterator = _createForOfIteratorHelper(mutations),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var mutation = _step.value;

        if (mutation.type === "attributes") {
          var target = mutation.target;
          var id = app.nodes.getID(target);

          if (id === undefined) {
            return;
          }

          if (mutation.attributeName === "src") {
            var src = target.src;
            app.send(new SetNodeAttributeURLBased(id, 'src', src, app.getBaseHref()));
          }

          if (mutation.attributeName === "srcset") {
            var srcset = target.srcset;
            app.send(new SetNodeAttribute(id, 'srcset', srcset));
          }
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  });
  app.nodes.attachNodeCallback(function (node) {
    if (!hasTag(node, "IMG")) {
      return;
    }

    app.nodes.attachElementListener('error', node, sendImgSrc);
    app.nodes.attachElementListener('load', node, sendImgSrc);
    sendImgSrc.call(node);
    observer.observe(node, {
      attributes: true,
      attributeFilter: ["src", "srcset"]
    });
  });
}